import { render, staticRenderFns } from "./5-1.vue?vue&type=template&id=18b37944&scoped=true&"
import script from "./5-1.vue?vue&type=script&lang=js&"
export * from "./5-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b37944",
  null
  
)

export default component.exports